import axios from "axios";
import env from "./env";

const axiosInstance = axios.create({
	baseURL: `${env.API_URL}${env.API_PORT ? `:${env.API_PORT}` : ""}/api`
});

export default axiosInstance;
